import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Heart, Calendar, Gift } from 'lucide-react';

const OcasionPage = () => {
  const { tipo } = useParams();
  const navigate = useNavigate();

  const ocasiones = {
    'amor-aniversario': {
      nombre: 'Flores para Amor y Aniversarios',
      descripcion: 'Rosas rojas, arreglos románticos y ramos especiales para celebrar el amor en Arequipa. Delivery express el mismo día.',
      detalles: [
        'Rosas rojas premium importadas',
        'Arreglos románticos personalizados',
        'Incluye tarjeta de amor',
        'Chocolates y peluches disponibles',
        'Entrega sorpresa disponible'
      ],
      imagenes: [
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/5f3f5c35-2c59-465d-4e09-c0cf93eee600/publicContain',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/33cd1368-94c3-4419-816b-25a0665aad00/public',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/3c289914-6f7b-48bf-5f2f-456ab5303900/public'
      ],
      keywords: 'rosas rojas arequipa, flores para aniversario arequipa, ramo de rosas arequipa, flores románticas arequipa'
    },
    'flores-amarillas': {
      nombre: 'Flores Amarillas para Amistad',
      descripcion: 'Girasoles, rosas amarillas y arreglos alegres para celebrar la amistad en Arequipa. Perfectos para el 21 de septiembre.',
      detalles: [
        'Girasoles frescos de temporada',
        'Rosas amarillas premium',
        'Arreglos alegres y coloridos',
        'Ideal para día del amor y la amistad',
        'Tarjeta personalizada incluida'
      ],
      imagenes: [
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/cd309af2-66cc-4721-cc51-72039ea2ab00/public',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/54aef800-701d-4185-5244-1ad2e1980900/public',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/a786cc17-edfc-44f5-7190-d8b1a4e5ae00/publicContain'
      ],
      keywords: 'girasoles arequipa, flores amarillas arequipa, rosas amarillas arequipa, flores para amistad arequipa'
    },
    'cumpleanos': {
      nombre: 'Flores para Cumpleaños',
      descripcion: 'Arreglos florales coloridos y alegres para cumpleaños en Arequipa. Incluye globos y peluches. Delivery el mismo día.',
      detalles: [
        'Arreglos coloridos y festivos',
        'Combinación con globos disponible',
        'Peluches de cumpleaños',
        'Tarta y chocolates opcionales',
        'Entrega sorpresa en el momento exacto'
      ],
      imagenes: [
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/2966eecc-e8a1-45fa-66f6-df9656ec7e00/publicContain',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/a786cc17-edfc-44f5-7190-d8b1a4e5ae00/publicContain',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/080fe01b-7b1a-47fc-e3ff-719967432100/publicContain'
      ],
      keywords: 'flores para cumpleaños arequipa, arreglos florales cumpleaños arequipa, flores delivery arequipa'
    },
    'dia-madre-padre': {
      nombre: 'Flores para Día de la Madre y Padre',
      descripcion: 'Arreglos especiales para homenajear a mamá y papá en Arequipa. Flores premium con delivery express.',
      detalles: [
        'Arreglos elegantes y sofisticados',
        'Flores premium de temporada',
        'Dedicatorias personalizadas',
        'Combos con chocolates y vinos',
        'Envío express garantizado'
      ],
      imagenes: [
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/0c6ec651-4d5b-41a1-7023-7d76371fd400/public',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/89bfcc7c-a9c8-443f-8fab-f50a81d06500/publicContain',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/a05fc3c6-28c6-47f3-8d07-3eb725c33800/publicContain'
      ],
      keywords: 'flores día de la madre arequipa, flores día del padre arequipa, regalos para mamá arequipa'
    },
    'dia-mujer': {
      nombre: 'Flores para el Día de la Mujer',
      descripcion: 'Hermosos arreglos florales para celebrar a las mujeres especiales en Arequipa. Catálogo exclusivo 8 de marzo.',
      detalles: [
        'Diseños exclusivos para mujer',
        'Rosas, lirios y tulipanes',
        'Presentación premium elegante',
        'Envío el mismo día',
        'Tarjeta de felicitación incluida'
      ],
      imagenes: [
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/cd309af2-66cc-4721-cc51-72039ea2ab00/public',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/5f3f5c35-2c59-465d-4e09-c0cf93eee600/publicContain',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/a05fc3c6-28c6-47f3-8d07-3eb725c33800/publicContain'
      ],
      keywords: 'flores día de la mujer arequipa, arreglos florales 8 de marzo arequipa, flores para mujer arequipa'
    },
    'graduacion': {
      nombre: 'Flores para Graduación',
      descripcion: 'Celebra el logro académico con hermosos arreglos florales en Arequipa. Perfectos para graduaciones universitarias y escolares.',
      detalles: [
        'Arreglos festivos y elegantes',
        'Colores personalizables',
        'Tamaños especiales',
        'Entrega en ceremonia disponible',
        'Combos con regalos'
      ],
      imagenes: [
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/a786cc17-edfc-44f5-7190-d8b1a4e5ae00/publicContain',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/89bfcc7c-a9c8-443f-8fab-f50a81d06500/publicContain',
        'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/54aef800-701d-4185-5244-1ad2e1980900/public'
      ],
      keywords: 'flores graduación arequipa, arreglos florales graduación arequipa, regalos graduación arequipa'
    }
  };

  const ocasion = ocasiones[tipo] || ocasiones['amor-aniversario'];

  const handleWhatsApp = () => {
    const mensaje = `Hola, me interesan ${ocasion.nombre}. ¿Podrían darme más información?`;
    window.open(`https://wa.me/51959389799?text=${encodeURIComponent(mensaje)}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-pink-50 pt-16 md:pt-20">
      {/* Breadcrumb */}
      <div className="bg-white py-4 px-4 border-b">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-2 text-sm">
            <button onClick={() => navigate('/')} className="text-pink-600 hover:text-pink-700">Inicio</button>
            <span className="text-gray-400">/</span>
            <button onClick={() => navigate('/ocasiones')} className="text-pink-600 hover:text-pink-700">Ocasiones</button>
            <span className="text-gray-400">/</span>
            <span className="text-gray-700">{ocasion.nombre}</span>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section className="py-12 md:py-16 px-4 bg-gradient-to-r from-pink-100 to-pink-50">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-pink-900 mb-4">
            {ocasion.nombre} en Arequipa
          </h1>
          <p className="text-lg md:text-xl text-pink-700 max-w-3xl mx-auto">
            {ocasion.descripcion}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 mb-16">
            {/* Images Grid */}
            <div className="grid grid-cols-2 gap-4">
              {ocasion.imagenes.map((img, idx) => (
                <div key={idx} className="bg-white rounded-2xl overflow-hidden shadow-xl">
                  <img 
                    src={img}
                    alt={`${ocasion.nombre} ${idx + 1} - Florería TQM Arequipa`}
                    className="w-full aspect-square object-cover hover:scale-110 transition-transform duration-300"
                  />
                </div>
              ))}
            </div>

            {/* Details */}
            <div>
              <div className="bg-white rounded-2xl p-6 md:p-8 shadow-xl mb-6">
                <h2 className="text-2xl font-bold text-pink-900 mb-6 flex items-center gap-3">
                  <Gift className="w-8 h-8 text-pink-600" />
                  Lo que Incluye:
                </h2>
                <ul className="space-y-4">
                  {ocasion.detalles.map((detalle, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <Heart className="w-5 h-5 text-pink-500 flex-shrink-0 mt-1" />
                      <span className="text-gray-700 text-base md:text-lg">{detalle}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-pink-100 rounded-2xl p-6 md:p-8 mb-6">
                <h3 className="text-xl font-bold text-pink-900 mb-4 flex items-center gap-3">
                  <Calendar className="w-6 h-6 text-pink-600" />
                  ¿Cuándo Ordenar?
                </h3>
                <p className="text-gray-700 mb-4">
                  Te recomendamos ordenar con al menos 1 día de anticipación para garantizar disponibilidad. 
                  Sin embargo, también aceptamos pedidos del mismo día según disponibilidad.
                </p>
                <p className="text-pink-800 font-semibold">
                  • Envío express: Menos de 3 horas<br/>
                  • Horario: Lunes a Sábado 8AM - 9PM<br/>
                  • Cobertura: Toda Arequipa
                </p>
              </div>

              <Button
                onClick={handleWhatsApp}
                className="w-full bg-green-500 hover:bg-green-600 text-white py-6 text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 font-bold"
              >
                <svg className="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                </svg>
                Consultar Disponibilidad
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Otras Ocasiones */}
      <section className="py-12 md:py-16 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-pink-900 mb-8 text-center">
            Otras Ocasiones Especiales
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
            {Object.entries(ocasiones)
              .filter(([key]) => key !== tipo)
              .slice(0, 6)
              .map(([key, oca]) => (
                <div
                  key={key}
                  onClick={() => {
                    navigate(`/ocasion/${key}`);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className="bg-pink-50 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 cursor-pointer"
                >
                  <img 
                    src={oca.imagenes[0]}
                    alt={`${oca.nombre} - TQM Florería Arequipa`}
                    className="w-full aspect-square object-cover"
                  />
                  <div className="p-4">
                    <h3 className="font-bold text-pink-900 text-sm md:text-base">{oca.nombre}</h3>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </section>
    </div>
  );
};

export default OcasionPage;